import { CreateToolbar, MapToolType } from "../createToolbar";

export class ToolbarFlyCameraHandler {
    private _firstLoadCamera = true;
    private _showHidePath = true;

    constructor(private toolbar: CreateToolbar) {}

    handle = (idElement: string) => {
        const containerId = this.toolbar._containerIdView;
        const listBtnToggle = [
            `fly-camera-${containerId}`,
            `fly-pause-${containerId}`,
            `fly-fast-${containerId}`,
            `fly-play-${containerId}`,
            `fly-slow-${containerId}`,
            `done-fly-${containerId}`,
            `fly-path-${containerId}`
        ];

        const listIdGroup = [
            `group-model-${containerId}`,
            `group-location-${containerId}`,
            `group-distance-${containerId}`,
            `group-data-${containerId}`,
            `data-element-${containerId}`
        ];

        const btnShow = listBtnToggle.slice(2, listBtnToggle.length - 1);

        switch (idElement) {
            case `fly-camera-${containerId}`:
                this.toolbar.deactivateOtherTools(MapToolType.FLY_CAMERA);
                this.toolbar._showHideElementsByID(listIdGroup, false);
                this.toolbar._showHideElementsByID(listBtnToggle, false);
                this.toolbar._showHideElementsByID(btnShow, true);

                this.toolbar.resetDialog(`fly-camera-${containerId}`);
                this.toolbar._contextMenu!.destroyContextMenu();
                break;

            case `fly-fast-${containerId}`:
                this.toolbar._flyCamera!.speedCameraMove(true);
                break;

            case `fly-play-${containerId}`:
                if (this._firstLoadCamera) {
                    this._firstLoadCamera = false;
                    this.toolbar._showHideElementByID(`fly-path-${containerId}`, true);
                    this.toolbar._flyCamera!.showHideModalCameraSetting(true);
                } else {
                    this.toolbar._flyCamera!.playCameraMove(true);
                }
                this.toolbar._showHideElementByID(`fly-play-${containerId}`, false);
                this.toolbar._showHideElementByID(`fly-pause-${containerId}`, true);
                this.toolbar._activeBtn(`fly-path-${containerId}`, this._showHidePath);
                break;

            case `fly-pause-${containerId}`:
                this.toolbar._showHideElementByID(`fly-play-${containerId}`, true);
                this.toolbar._showHideElementByID(`fly-pause-${containerId}`, false);
                this.toolbar._flyCamera!.playCameraMove(false);
                break;

            case `fly-slow-${containerId}`:
                this.toolbar._flyCamera!.speedCameraMove(false);
                break;

            case `fly-path-${containerId}`:
                this._showHidePath = !this._showHidePath;
                this.toolbar._flyCamera!.showHidePointPath(this._showHidePath);
                this.toolbar._activeBtn(`fly-path-${containerId}`, this._showHidePath);
                break;

            case `done-fly-${containerId}`:
                this.toolbar._contextMenu!.createContextMenu();

                this.toolbar._showHideElementsByID(listIdGroup, true);
                this.toolbar._showHideElementsByID(listBtnToggle, false);
                this.toolbar._showHideElementByID(`fly-camera-${containerId}`, true);
                this.toolbar._showHideElementByID(`label-properties-${containerId}`, true);
                this.toolbar._showHideElementByID(`group-note-${containerId}`, true);
                
                this._firstLoadCamera = true;
                this._showHidePath = true;
                
                this.toolbar._flyCamera!.resetCameraMove();
                this.toolbar._flyCamera!.showHideModalCameraSetting(false);
                break;

            default:
                break;
        }

        if (this.toolbar._flyCamera) {
            this.toolbar._flyCamera.setClosedCallback((status: boolean) => {
                if (!status) {
                    this.toolbar.ToolBarActionFlyCamera(`done-fly-${containerId}`);
                }
            });
        }
    };
}
